import * as ActionType from '../actions/types'

export const INITIAL_STATE = {
  initialFilterSet: true, // flag will set, if user changes the initial filter set
  activeSort: '',
  sorting: [], // sort options
  collection: [], // filter collection
}

/**
 * filter reducer
 * @param state
 * @param action
 * @returns {{sorting: {}, activeSort: boolean, collection: {}, initialFilterSet: boolean}|{sorting: {}, activeSort: boolean, collection: {}, initialFilterSet: boolean}|{sorting: {}, activeSort: *, collection: {}, initialFilterSet: boolean}|{sorting: {}, activeSort: boolean, collection: {}, initialFilterSet: boolean}}
 */
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_FILTERS:
      return {
        ...state,
        collection: action.payload.collection,
        sorting: action.payload.sorting,
        activeSort: action.payload.activeSort,
        initialFilterSet: true,
      }

    case ActionType.UPDATE_FILTERS:
      return {
        ...state,
        collection: action.payload.collection,
        activeSort: action.payload.activeSort,
        initialFilterSet: false,
      }

    case ActionType.SET_SORT_BY:
      return {
        ...state,
        activeSort: action.payload,
      }

    case ActionType.RESET_FILTERS:
      return {
        ...INITIAL_STATE,
      }

    case ActionType.UPDATE_SORTING:
      return {
        ...INITIAL_STATE,
        activeSort: action.payload,
      }

    default:
      return state
  }
}
